import { c as _c } from "react/compiler-runtime";
import { Box, Flex, IconButton, Stack, Text } from "@chakra-ui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import type { JunctionMovementRow } from "./junctionMovementRows";
import { vehicleTypeLabels } from "@/utils/vehicleTypeUtils";
export interface JunctionMovementDetailCardProps {
  junctionLabel: string;
  row: JunctionMovementRow;
  onBack: () => void;
}
const messages = defineMessages({
  totalVehicleCounts: {
    id: "junctionMovementDetailCard.totalVehicleCounts",
    defaultMessage: "Total Vehicle Counts"
  },
  pillLabel: {
    id: "junctionMovementDetailCard.pillLabel",
    defaultMessage: "Movement from {entry} to {exit}"
  },
  back: {
    id: "junctionMovementDetailCard.back",
    defaultMessage: "Back"
  }
});
const numberFormatter = new Intl.NumberFormat("en-US");
export const JunctionMovementDetailCard = t0 => {
  const $ = _c(71);
  const {
    junctionLabel,
    row,
    onBack
  } = t0;
  const intl = useIntl();
  const entryGateLabel = row.movement.entryGate.label;
  const exitGateLabel = row.movement.exitGate.label;
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== entryGateLabel || $[1] !== exitGateLabel || $[2] !== intl || $[3] !== junctionLabel || $[4] !== onBack || $[5] !== row.color || $[6] !== row.total || $[7] !== row.vehicleCounts) {
    const sortedCounts = [...row.vehicleCounts].sort(_temp);
    T1 = Box;
    t7 = "junction-movement-detail-card";
    t8 = "cardBg";
    t9 = "card";
    t10 = "elevated";
    t11 = "4";
    t12 = "legendCard";
    let t17;
    if ($[26] !== intl) {
      t17 = intl.formatMessage(messages.back);
      $[26] = intl;
      $[27] = t17;
    } else {
      t17 = $[27];
    }
    let t18;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <ArrowBackIcon />;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    if ($[29] !== onBack || $[30] !== t17) {
      t13 = <Flex justify="flex-end"><IconButton data-testid="junction-movement-detail-card-back-button" aria-label={t17} onClick={onBack} variant="ghost" size="sm">{t18}</IconButton></Flex>;
      $[29] = onBack;
      $[30] = t17;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    if ($[32] !== junctionLabel) {
      t14 = <Text data-testid="junction-movement-detail-card-title" fontSize="lg" fontWeight="bold" color="text">{junctionLabel}</Text>;
      $[32] = junctionLabel;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    const t19 = row.color;
    let t20;
    if ($[34] !== entryGateLabel || $[35] !== exitGateLabel || $[36] !== intl) {
      t20 = intl.formatMessage(messages.pillLabel, {
        entry: entryGateLabel,
        exit: exitGateLabel
      });
      $[34] = entryGateLabel;
      $[35] = exitGateLabel;
      $[36] = intl;
      $[37] = t20;
    } else {
      t20 = $[37];
    }
    let t21;
    if ($[38] !== entryGateLabel || $[39] !== exitGateLabel) {
      t21 = <Text fontSize="sm" fontWeight="bold" color="white">{entryGateLabel} › {exitGateLabel}</Text>;
      $[38] = entryGateLabel;
      $[39] = exitGateLabel;
      $[40] = t21;
    } else {
      t21 = $[40];
    }
    if ($[41] !== row.color || $[42] !== t20 || $[43] !== t21) {
      t15 = <Box data-testid="junction-movement-detail-card-pill" bg={t19} borderRadius="pill" px="3" py="1" mt="2" display="inline-block" aria-label={t20}>{t21}</Box>;
      $[41] = row.color;
      $[42] = t20;
      $[43] = t21;
      $[44] = t15;
    } else {
      t15 = $[44];
    }
    let t22;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <Text fontSize="sm" color="textMuted" maxWidth="legendLabel"><FormattedMessage {...messages.totalVehicleCounts} /></Text>;
      $[45] = t22;
    } else {
      t22 = $[45];
    }
    let t23;
    if ($[46] !== row.total) {
      t23 = numberFormatter.format(row.total);
      $[46] = row.total;
      $[47] = t23;
    } else {
      t23 = $[47];
    }
    if ($[48] !== t23) {
      t16 = <Flex data-testid="junction-movement-detail-card-total-row" mt="4" pt="4" borderTopWidth="1px" borderTopColor="border" align="center" justify="space-between" gap="2">{t22}<Text data-testid="junction-movement-detail-card-total" fontSize="4xl" fontWeight="bold" color="text">{t23}</Text></Flex>;
      $[48] = t23;
      $[49] = t16;
    } else {
      t16 = $[49];
    }
    T0 = Stack;
    t1 = "4";
    t2 = "4";
    t3 = "1px";
    t4 = "border";
    t5 = "2";
    t6 = sortedCounts.map(_temp2);
    $[0] = entryGateLabel;
    $[1] = exitGateLabel;
    $[2] = intl;
    $[3] = junctionLabel;
    $[4] = onBack;
    $[5] = row.color;
    $[6] = row.total;
    $[7] = row.vehicleCounts;
    $[8] = T0;
    $[9] = T1;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
    $[17] = t16;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[8];
    T1 = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
    t16 = $[17];
    t2 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t17;
  if ($[50] !== T0 || $[51] !== t1 || $[52] !== t2 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6) {
    t17 = <T0 mt={t1} pt={t2} borderTopWidth={t3} borderTopColor={t4} gap={t5}>{t6}</T0>;
    $[50] = T0;
    $[51] = t1;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] !== T1 || $[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== t13 || $[63] !== t14 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t7 || $[68] !== t8 || $[69] !== t9) {
    t18 = <T1 data-testid={t7} bg={t8} borderRadius={t9} boxShadow={t10} p={t11} maxWidth={t12}>{t13}{t14}{t15}{t16}{t17}</T1>;
    $[58] = T1;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t7;
    $[68] = t8;
    $[69] = t9;
    $[70] = t18;
  } else {
    t18 = $[70];
  }
  return t18;
};
function _temp(a, b) {
  return b.count - a.count;
}
function _temp2(entry) {
  return <Flex key={entry.vehicleType} data-testid={`junction-movement-detail-card-row-${entry.vehicleType}`} align="center" justify="space-between" gap="2"><Text fontSize="sm" color="text"><FormattedMessage {...vehicleTypeLabels[entry.vehicleType]} /></Text><Text data-testid={`junction-movement-detail-card-count-${entry.vehicleType}`} fontSize="sm" fontWeight="bold" color="text">{numberFormatter.format(entry.count)}</Text></Flex>;
}